import {makeStyles} from '@material-ui/core/styles'
import FormikField from '../../../1elements/Fields/FormikField'
import {validateText} from '../../../../services/formikValidation/validation'
import CustomField from './CustomField'

const EditItem = ({item, index, fieldIndex, formikProps}) => {
    const classes = useStyles()
    const name = `values[${index}].cardData[${fieldIndex}].fieldData`

    return (
        <CustomField name={name} className={classes.root}>
            <FormikField name={name} className={classes.textField} validate={validateText} component={'textarea'}/>
        </CustomField>
    )
}

export default EditItem

const useStyles = makeStyles({
    textField: {
        width: '100%',
        height: '100% !important',
        marginTop: 5,

        '& .MuiInputBase-input': {
            boxShadow: '0px 3px 6px #00000029',
            padding: '1px 3px',
            width: '100%',
        }
    },
    root: {
        height: '100%'
    }
})